(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ragland-project-automated"] && !Shopify.designMode) return;
  try {
    function initRaglandProject(scope=document){scope.querySelectorAll('[data-ragland-project]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const form=root.querySelector('form'),select=root.querySelector('select'),quantity=root.querySelector('[name="quantity"]'),range=root.querySelector('[type="range"]'),button=root.querySelector('button'),money=n=>'R'+n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,' ');function update(){const n=Number(quantity.value),valid=quantity.value!==''&&Number.isInteger(n)&&n>=1&&n<=50,rate=n>=20?92:n>=10?95:100,opt=select.selectedOptions[0],available=opt&&opt.dataset.available==='true';quantity.setCustomValidity(valid?'':root.dataset.invalid);button.disabled=!valid||!available;button.textContent=available?root.dataset.add:root.dataset.soldOut;root.querySelector('.rp-error').textContent=valid?'':root.dataset.invalid;root.querySelector('output').textContent=valid?money(n*rate):'—';root.querySelector('.rp-rate').textContent=valid?n+' m × '+money(rate)+' / m':'';root.querySelector('.rp-total').hidden=false;root.querySelectorAll('[data-tier]').forEach(t=>t.classList.toggle('active',valid&&Number(t.dataset.tier)===rate));if(valid)range.value=n;if(opt){root.querySelector('.rp-image').src=opt.dataset.image;root.querySelector('.rp-image').alt=opt.textContent;root.querySelector('.rp-rolls').href=opt.dataset.url;}}range.addEventListener('input',()=>{quantity.value=range.value;update()});quantity.addEventListener('input',update);select.addEventListener('change',update);form.addEventListener('submit',e=>{update();if(button.disabled||!form.checkValidity()){e.preventDefault();form.reportValidity();}else{button.disabled=true;setTimeout(()=>update(),2000)}});update();});}initRaglandProject();document.addEventListener('shopify:section:load',e=>initRaglandProject(e.target));window.addEventListener('pageshow',()=>document.querySelectorAll('[data-ragland-project] [name="quantity"]').forEach(e=>e.dispatchEvent(new Event('input'))));
  } catch(e) { console.error(e); }
})();
})();
